import * as Yup from 'yup'
import {UserRole, UserStatus} from '../../../../../interfaces/user'
import {ErrorForms} from '../../../../../libs/_fri/utils/enums'

export interface IFormCreateUser {
  name: string
  email: string
  phoneNumber: string
  role: UserRole | string
}

export const schemaCreateUser = Yup.object().shape({
  name: Yup.string().required(ErrorForms.GenericError),
  email: Yup.string().email(ErrorForms.InvalidEmail).required(ErrorForms.GenericError),
  phoneNumber: Yup.string()
    .matches(/^[0-9]{8}$/, ErrorForms.InvalidPhone)
    .required(ErrorForms.GenericError),
  role: Yup.string().required(ErrorForms.GenericError),
})

export interface IFormEditUser {
  name: string
  email: string
  phoneNumber: string
  status: UserStatus
}

export const schemaEditUser = Yup.object().shape({
  name: Yup.string().required(ErrorForms.GenericError),
  email: Yup.string().email(ErrorForms.InvalidEmail).required(ErrorForms.GenericError),
  phoneNumber: Yup.string()
    .matches(/^[0-9]{8}$/, ErrorForms.InvalidPhone)
    .required(ErrorForms.GenericError),
  status: Yup.mixed<UserStatus>().required(ErrorForms.GenericError),
})
